import AWS from 'aws-sdk';
const S3_URL = process.env.REACT_APP_S3_URL || `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/`;
// Set up AWS credentials from environment variables
const credentials = {
    accessKeyId: process.env.REACT_APP_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY
};

// Update the AWS configuration with credentials
AWS.config.update(credentials);

// Export the AWS object
export default {AWS, S3_URL};

